import { initUploadQueue } from '~/lib/uploadqueue'

export default defineNuxtPlugin((nuxtApp) => {
  initUploadQueue(nuxtApp.$store, nuxtApp.$eventbus)
})
